import { Button, IconButton, Textarea, Tooltip, Typography } from "@mui/joy";
import { currencyColumn, dateColumn, genericColumn, getColumnValue, numberColumn, textColumn, textareaColumn, yesNoColumn } from "./columnHelpers";
import ObjectPreview from "@components/objects/ObjectPreview";
import ChecklistRoundedIcon from '@mui/icons-material/ChecklistRounded';
import Diversity3RoundedIcon from '@mui/icons-material/Diversity3Rounded';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import { useState } from "react";
import { AddTimeModal } from "@components/AddTimeModal";
import { useParams } from "react-router-dom";
import { useFormContext } from "react-hook-form";

export const volunteerHoursRelationship = {
    collapsible: true,
    title: 'Volunteer Hours',
    tint: 'default',
    type: 'table',
    sort: ['volunteered_at', 'desc'],
    columns: [
        genericColumn({
            label: 'Entry',
            column: 'entry',
            editableAfterSave: false,
            render: {
                show: (object) => {
                    return (<>
                        {object.task_id && (
                            <ObjectPreview to={`/work-plans/${object.task_info.workplan_id}`}><ChecklistRoundedIcon/> {object.task_info.task_name}</ObjectPreview>
                        )}

                        {object.opportunity_sign_up_id && !object?.opportunity && (
                            <em>Deleted Opportunity</em>
                        )}
                        {object.opportunity_sign_up_id && !!object?.opportunity && (
                            <ObjectPreview to={`/opportunities/${object.opportunity.id}`}><Diversity3RoundedIcon/> {object.opportunity.name}</ObjectPreview>
                        )}

                        {!object.task_id && !object.opportunity_sign_up_id && (
                            <>Quick Add</>
                        )}

                        {object.notes && (
                            <Typography fontSize={'sm'}>{object.notes}</Typography>
                        )}
                    </>)
                },
           },
        }),
        textColumn({label: 'Hours', column: 'time_taken'}),
        dateColumn({column: 'volunteered_at', className: 'min'}),
    ],
};

const TimeAdder = ({includeText = false}) => {
    const [addTimeOpen, setAddTimeOpen] = useState(false);
    const { id } = useParams();

    const { control, register, setValue, getValues, watch } = useFormContext();
    const contact = getValues() ?? null;

    const disabled = !id;

    const clickHandler = () => {
        if(!id) {
            alert('You cannot add volunteer hours to a new conatct. Please save first.');
            return;
        }

        setAddTimeOpen(true);
    }

    const onLogTime = (response) => {
        if(!contact) {
            return;
        }

        let volunteerHours = contact.volunteer_hours ?? [];
        volunteerHours.push(response);
        //onLogTime
        setValue('volunteer_hours', volunteerHours);
    }

    return (<>
        {includeText === true && (<>
            <Button
                size="sm"
                variant="soft"
                color="neutral"
                onClick={clickHandler}
                disabled={disabled}
                sx={{
                bgcolor: 'background.level1',
                '--variant-outlinedHoverBg': '#FFFFFF6B',
                '--variant-outlinedActiveBg': '#FFFFFFB8',// theme.palette.background.level1
                '--IconButton-size': '1.65rem',
                'svg': {
                    width: '1.05rem',
                    height: '1.05rem',
                }
                }}
                startDecorator={<AddRoundedIcon/>}
            >
                Add Row{disabled && ' (You must save first)'}
            </Button>
        </>)}
        {includeText !== true && (<>
        <Tooltip title="Log Time">
            <IconButton
                size="sm"
                color="neutral"
                onClick={clickHandler}
                disabled={disabled}
                sx={{
                bgcolor: 'background.level1',
                '--variant-outlinedHoverBg': '#FFFFFF6B',
                '--variant-outlinedActiveBg': '#FFFFFFB8',// theme.palette.background.level1
                '--IconButton-size': '1.65rem',
                'svg': {
                    width: '1.05rem',
                    height: '1.05rem',
                }
                }}
            >
                <AddRoundedIcon/>
            </IconButton>
        </Tooltip>
        </>)}
        <AddTimeModal
            contact={contact}
            open={addTimeOpen}
            setOpen={setAddTimeOpen}
            onLogTime={onLogTime}
            //   task={task}
        />
    </>);
}

export const volunteerHoursRelationshipEdit = {
    collapsible: true,
    virtualized: true,
    title: 'Volunteer Hours',
    tint: 'default',
    type: 'table',
    sort: ['volunteered_at', 'desc'],

    customAction: <TimeAdder/>,
    customEmptyAction: <TimeAdder includeText/>,

    columns: [
        genericColumn({
            label: 'Entry',
            column: 'entry',
            type: 'custom',
            editableAfterSave: false,
            width: 'auto',
            render: {
                show: (object) => {
                    if(object.task_id) {
                        return <ObjectPreview to={`/work-plans/${object.task_info.workplan_id}`}><ChecklistRoundedIcon/> {object.task_info.task_name}</ObjectPreview>
                    }

                    if(object.opportunity_sign_up_id) {
                        if(!object?.opportunity) {
                            return <em>Deleted Opportunity</em>;
                        }

                        return <ObjectPreview to={`/opportunities/${object.opportunity.id}`}><Diversity3RoundedIcon/> {object.opportunity.name}</ObjectPreview>
                    }

                    return <>Quick Add</>;
                },
                editDisabled: (object) => {
                    if(object.task_id) {
                        return <><ChecklistRoundedIcon/> {object.task_info.task_name}</>
                    }

                    if(object.opportunity_sign_up_id) {
                        if(!object?.opportunity) {
                            return <em>Deleted Opportunity</em>;
                        }

                        return <><Diversity3RoundedIcon/> {object.opportunity.name}</>
                    }

                    return <>Quick Add</>;
                },
                /*
                edit: ({rowIndex, row, data, setRowValue}) => {
                    return (<>
                        {row.task_id && (
                            <ObjectPreview to={`/work-plans/${row.task_info.workplan_id}`}><ChecklistRoundedIcon/> {row.task_info.task_name}</ObjectPreview>
                        )}

                        {row.opportunity_sign_up_id && (
                            <ObjectPreview to={`/opportunities/${row.opportunity.id}`}><Diversity3RoundedIcon/> {row.opportunity.name}</ObjectPreview>
                        )}

                        {!row.task_id && !row.opportunity_sign_up_id && (
                            <>Quick Add</>
                        )}

                        <Textarea
                        sx={{mt: 1}}
                        value={row.notes}
                        placeholder={'Notes...'}
                        onChange={(e) => {
                            // console.log(e.target.value);
                            setRowValue(rowIndex, 'notes', e.target.value);

                        }}
                        />
                    </>)
                },
                */
           },
        }),
        textColumn({label: 'Hours', column: 'time_taken', width: '15%'}),
        dateColumn({column: 'volunteered_at'/*, className: 'min'*/}),
        textareaColumn({
            label: 'Notes',
            column: 'notes',
            // editableAfterSave: true,
        }),
    ],
};
